import { styled } from "@mui/material"
import { useNotificationContext } from "../../contexts/NotificationContext"
import { SettingCheckbox } from "../../SettingCheckbox"
import { AlertDefinitions } from "./AlertDefinitions"
import { AlertLevelRadioGroup } from "./AlertLevelRadioGroup"

const AlertsContainer = styled("div")({
  display: "grid",
  gridAutoFlow: "row",
  gap: 12,
  paddingRight: "26px",
})

const AlertLevelDetailContainer = styled("div")({
  marginLeft: 26,
})

export const Alerts: React.FC = () => {
  const { alertsEnabled, setAlertsEnabled } = useNotificationContext()

  return (
    <AlertsContainer>
      <SettingCheckbox
        settingEnabled={alertsEnabled || false}
        setSettingEnabled={setAlertsEnabled}
        title="Pulses"
      />
      {alertsEnabled && (
        <AlertLevelDetailContainer>
          <AlertLevelRadioGroup />
          <AlertDefinitions />
        </AlertLevelDetailContainer>
      )}
    </AlertsContainer>
  )
}
